module.exports = __webpack_public_path__ + "static/img/dashboard__hovered.d7294c3.svg";